import React from 'react';
import { Loader2 } from 'lucide-react';

const SIZES = {
  sm: 16,
  md: 22,
  lg: 32,
};

/**
 * Inline spinner. Use `label` for a full loading state (e.g. inside a page or panel).
 */
export function Loader({ size = 'md', className = '', label }) {
  const px = SIZES[size] || SIZES.md;

  return (
    <span className={`inline-flex items-center gap-2 text-current ${className}`}>
      <Loader2 size={px} className="animate-spin" />
      {label && <span className="text-sm font-medium">{label}</span>}
    </span>
  );
}

/**
 * Centered full-height loading state, for pages/sections waiting on data.
 */
export function PageLoader({ label = 'Loading...' }) {
  return (
    <div className="flex min-h-[200px] w-full flex-col items-center justify-center gap-3 text-brand-600">
      <Loader2 size={36} className="animate-spin" />
      <p className="text-sm font-medium text-slate-500">{label}</p>
    </div>
  );
}

export default Loader;
